import { Box, Text, TextInput } from "grommet"

const TextInputWithUnit = ({ unit, ...props }) => {

    return (
        <Box direction="row" align="center" gap="xsmall">
            <TextInput onBeforeInput={(event) => console.log(event)} {...props} />
            <Text color="text-weak" size="small">{unit}</Text>
        </Box>
    )
}

export default TextInputWithUnit;